import { Plugin } from '@ckeditor/ckeditor5-core';
import DynamicNameEditing from './dynamicnameediting';
import DynamicNameUI from './dynamicnameui';

export default class DynamicName extends Plugin {
	static get requires() {
		return [ DynamicNameEditing, DynamicNameUI ];
	}
}